import * as React from "react";
const SvgFiRrFog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fog_svg__a)">
      <path
        fill="#062147"
        d="M18 24h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 0 2m-5 0H6a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2m5-4h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2M7 20H6a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2m-4.33-1a1 1 0 0 1-.628-.223A5.533 5.533 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.1 8.1 0 0 1-.032-2.89A7.945 7.945 0 0 1 8.5.138a8.05 8.05 0 0 1 8.735 4.438 1.04 1.04 0 0 0 .742.57c5.825 1.034 8.093 8.77 3.718 12.765a1 1 0 1 1-1.384-1.443 5.538 5.538 0 0 0-2.724-9.362 3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.085 6.967a6.2 6.2 0 0 0 .023 2.18 3 3 0 0 1-.963 2.762 3.523 3.523 0 0 0 .154 5.314A1 1 0 0 1 2.67 19M18 16h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2m-5 0H6a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFog;
